import { sortAscListOfNum } from 'helpers/array.helper';
import { isHigher } from 'helpers/math.helper';
import { isEqualVal } from 'helpers/string.helper';
import { filter, map, uniqBy } from 'lodash';
import { FramePhotoModel } from 'models/photo/frame.model';
import { LayoutPhotoModel } from 'models/photo/layout.model';

const getListQuantityOfPerSheet = (
  list: Array<LayoutPhotoModel> | undefined,
  frameId: FramePhotoModel['id'] | null | undefined,
) =>
  sortAscListOfNum(
    map(
      uniqBy(
        filter(list, (o) => isEqualVal(o?.frameId, frameId)),
        'numberOfPicture',
      ),
      'numberOfPicture',
    ),
  );

const filterListLayoutByQuantity = (
  list: Array<LayoutPhotoModel> | undefined,
  frameId: FramePhotoModel['id'] | null | undefined,
  numberOfPhoto: number,
): Array<LayoutPhotoModel> =>
  filter(
    list,
    (o) =>
      isEqualVal(o?.frameId, frameId) && o.numberOfPicture === numberOfPhoto,
  );

// Hàm sắp xếp layouts
const sortLayoutsByCodePrefix = (layouts: LayoutPhotoModel[]) => {
  const prefixOrder = ['26', '46', '620'];

  return [...layouts].sort((a, b) => {
    // Ưu tiên ảnh dọc (height > width) lên trước
    const aIsVertical = isHigher(a.height, a.width);
    const bIsVertical = isHigher(b.height, b.width);

    if (aIsVertical && !bIsVertical) return -1; // a dọc, b ngang -> a lên trước
    if (!aIsVertical && bIsVertical) return 1; // a ngang, b dọc -> b lên trước

    // Nếu cùng orientation (cùng dọc hoặc cùng ngang), sắp xếp theo code prefix
    const aPrefix = prefixOrder.findIndex((prefix) =>
      a.code?.startsWith(prefix),
    );
    const bPrefix = prefixOrder.findIndex((prefix) =>
      b.code?.startsWith(prefix),
    );

    // Nếu cả 2 đều không match với prefix order, giữ nguyên thứ tự
    if (aPrefix === -1 && bPrefix === -1) return 0;
    // Nếu a không match, đẩy xuống cuối
    if (aPrefix === -1) return 1;
    // Nếu b không match, đẩy xuống cuối
    if (bPrefix === -1) return -1;

    // So sánh theo thứ tự prefix
    if (aPrefix !== bPrefix) {
      return aPrefix - bPrefix;
    }

    // Nếu cùng prefix, sắp xếp theo code
    return a.code.localeCompare(b.code);
  });
};

export {
  getListQuantityOfPerSheet,
  filterListLayoutByQuantity,
  sortLayoutsByCodePrefix,
};
